<template>
  <div class="crop-image">
    <div class="text-center">
      <h2>Chọn ảnh</h2>
    </div>
    <div class="crop-window">
      <vue-cropper
        ref="cropper"
        v-bind="options"
      />
      <div class="d-flex actions-wrapper text-center m-3">
        <range-slider
          class="slider"
          v-bind="sliderOptions"
          v-model="sliderValue">
        </range-slider>
        <div class="rotate-action d-flex">
          <button @click="rotateLeft" class="btn">
            <i class="fa fa-"
          </button>
          <button @click="rotateRight" class="btn">
            Right
          </button>
        </div>
      </div>
    </div>   
    
      <div class="text-center">
        <button class="btn btn-secondary mr-2" @click="closeCrop">
          Hủy bỏ
        </button>
        <button class="btn btn-secondary" @click="getCropImage">
          Chọn
        </button>
      </div>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import RangeSlider from 'vue-range-slider'

import 'vue-range-slider/dist/vue-range-slider.css'

export default {
  props: ['imageUrl'],
  data () {
    return {
      sliderOptions: {
        min: 10,
        max: 100,
        step: 5
      },
      sliderValue: 15,
      options: {
        img: this.imageUrl,
        full: true,
        canMove: true,
        fixedBox: true,
        autoCropWidth: 280,
        autoCropHeight: 280,
        autoCrop: true,
        fixedNumber: [1, 1],
        fixed: true
      }
    }
  },
  components: {
    VueCropper,
    RangeSlider
  },
  methods: {
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    closeCrop () {
      this.$emit('close')
    },
    getCropImage () {
      this.$refs.cropper.getCropData(data => {
        this.$parent.$emit('get-data', data)
        this.closeCrop()
      })
    }
  },
  watch: {
    sliderValue (newVal, oldVal) {
      return this.$refs.cropper.changeScale(newVal - oldVal)
    }
  }
}
</script>
<style>
.vue-cropper {
    width: 400px !important;
    height: 400px !important;
}
</style>